"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = __importDefault(require("classnames"));
const react_1 = require("react");
function ExternalLink({ children, className = '', href, styleAsAnchor = false, ...rest }) {
    // Ensure that all web addresses begin with a protocol (the expectation). If
    // they don't, assume the current protocol (typically https) by prepending
    // "//" to the URL.
    const normalizedUrl = href.startsWith('http') ? href : `//${href}`;
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("a", { className: styleAsAnchor ? '' : (0, classnames_1.default)('external-link', className), target: "_blank", rel: "noopener noreferrer", href: normalizedUrl, ...rest, children: children }), (0, jsx_runtime_1.jsx)("span", { hidden: true, children: "Opens in a new window" })] }));
}
exports.default = (0, react_1.memo)(ExternalLink);
